import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export const initialQuote = {
  dbquote: {
    id: null,
    docusign_ref: null,
    quote_status_code: 'DRAFT'
  },
  erpquote: {
    erpQuoteRef: null,
    status: null,
    // Vehicle details
    product: {},
    make: {},
    bodyType: {},
    model: {},
    variant: {},
    // Lease Details
    leaseStart: null,
    leaseEnd: null,
    availableOptions: {},
    leaseTerm: null,
    kmsPerYear: null,
    // Colour and extras
    exteriorColour: {},
    interiorColour: {},
    optionalEquipment: [],
    adhocEquipment: [],
    // Order Details
    customer: {
      companyName: null,
      companyAbn: null,
      customerName: null,
      customerContactNumber: null,
      customerContactEmail: null,
      deliveryAddressLine1: null,
      deliveryAddressLine2: null,
      deliverySuburb: null,
      deliveryState: null,
      deliveryPostcode: null,
      deliveryDate: null,
      dealership: null,
      registrationPostcode: null
    },
    price: {
      onRoadCost: null,
      monthlyRentalNet: null,
      weeklyRentalNet: null
    }
  }
};

export default {
  namespaced: true,
  state: {
    quote: { ...initialQuote }
  },
  getters: { ...getters },
  mutations: mutations,
  actions: actions
};
